/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Agenda from 'react-big-calendar/lib/Agenda';
import Day from 'react-big-calendar/lib/Day';
import Month from 'react-big-calendar/lib/Month';
import Week from 'react-big-calendar/lib/Week';
import WorkWeek from 'react-big-calendar/lib/WorkWeek';

import { useTranslation } from '../../../custom-hooks/useTranslation';

export function MonthView(props) {
  return (
    <div className="rbc-month-view" ui-ta="MonthView">
      <Month {...props} />
    </div>
  );
}

MonthView.title = Month.title;
MonthView.navigate = Month.navigate;

export function WeekView(props) {
  return (
    <div className="rbc-time-view" ui-ta="WeekView">
      <Week {...props} />
    </div>
  );
}

WeekView.title = Week.title;
WeekView.navigate = Week.navigate;

export function WorkWeekView(props) {
  return (
    <div className="rbc-time-view" ui-ta="WorkWeek">
      <WorkWeek {...props} />
    </div>
  );
}

WorkWeekView.title = WorkWeek.title;
WorkWeekView.navigate = WorkWeek.navigate;

export function DayView(props) {
  return (
    <div className="rbc-time-view" ui-ta="DayView">
      <Day {...props} />
    </div>
  );
}

DayView.title = Day.title;
DayView.navigate = Day.navigate;

export function AgendaView(props) {
  const translateString = useTranslation();
  const noEventsInRangeMessage = props.localizer.messages?.noEventsInRange || ' ';
  props.localizer.messages.noEventsInRange = translateString(noEventsInRangeMessage);
  return (
    <div className="rbc-agenda-view" ui-ta="AgendaView">
      <Agenda {...props} />
    </div>
  );
}

AgendaView.title = Agenda.title;
AgendaView.navigate = Agenda.navigate;
